import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { auth } from "./firebase"
import { onAuthStateChanged } from "firebase/auth"

import SmoothScroll from "./SmoothScroll"

import Navbar from "./components/Navbar"
import Hero from "./components/Hero"
import WhatWeDo from "./components/WhatWeDo"
import WhyTrustUs from "./components/WhyTrustUs"
import OurConnections from "./components/OurConnections"
import Footer from "./components/Footer"
import Database from "./components/Database"
import Services from "./components/Services"

import Login from "./auth/Login"
import Signup from "./auth/Signup"
import VerifyEmail from "./auth/VerifyEmail"

import Dashboard from "./main/Dashboard"
import NavbarDashboard from "./main/NavbarDashboard"
import AboutYou from "./main/AboutYou"
import Feed from "./main/Feed"
import GoalFeed from "./main/GoalFeed"
import About from "./components/About"
import Contact from "./components/Contact"
import Security from "./components/Security"
import Explore from "./main/Explore"
import OpportunityBlog from "./main/OpportunityBlog"

import "./App.css"

function App() {

  const [user, setUser] = useState(undefined)

  useEffect(() => {

    const unsubscribe = onAuthStateChanged(auth, async currentUser => {

      if (currentUser) {
        await currentUser.reload()
        setUser({ ...currentUser })
      } else {
        setUser(null)
      }

    })

    return () => unsubscribe()

  }, [])

  if (user === undefined) return null

  return (

    <BrowserRouter>

      <SmoothScroll />

      <Routes>

        <Route path="/" element={<Navigate to="/home" replace />} />

        <Route
          path="/verify-email"
          element={
            user &&
            user.providerData[0]?.providerId === "password" &&
            !user.emailVerified ? (
              <>
                <Navbar />
                <VerifyEmail />
              </>
            ) : (
              <Navigate to="/dashboard" replace />
            )
          }
        />

        <Route
          path="/dashboard"
          element={
            user ? (
              user.providerData[0]?.providerId === "password" &&
              !user.emailVerified ? (
                <Navigate to="/verify-email" replace />
              ) : (
                <>
                  <NavbarDashboard />
                  <Dashboard />
                </>
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/dashboard/about-you"
          element={
            user ? (
              <>
                <NavbarDashboard />
                <AboutYou />
              </>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/dashboard/feed"
          element={
            user ? (
              user.providerData[0]?.providerId === "password" &&
              !user.emailVerified ? (
                <Navigate to="/verify-email" replace />
              ) : (
                <>
                  <Feed />
                </>
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/dashboard/goal"
          element={
            user ? (
              user.providerData[0]?.providerId === "password" &&
              !user.emailVerified ? (
                <Navigate to="/verify-email" replace />
              ) : (
                <>
                  <GoalFeed />
                </>
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/dashboard/explore"
          element={
            user ? (
              user.providerData[0]?.providerId === "password" &&
              !user.emailVerified ? (
                <Navigate to="/verify-email" replace />
              ) : (
                <>
                  <NavbarDashboard />
                  <Explore />
                </>
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/login"
          element={
            user ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <>
                <Navbar />
                <Login />
              </>
            )
          }
        />

        <Route
          path="/signup"
          element={
            user ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <>
                <Navbar />
                <Signup />
              </>
            )
          }
        />

        <Route
          path="/home"
          element={
            <>
              <Navbar />
              <Hero />
              <WhatWeDo />
              <WhyTrustUs />
              <div id="our-connections">
                <OurConnections />
              </div>
              <Footer />
            </>
          }
        />

        <Route
          path="/about"
          element={
            <>
              <Navbar />
              <About />
              <Footer />
            </>
          }
        />

        <Route
          path="/database"
          element={
            <>
              <Navbar />
              <Database />
              <Footer />
            </>
          }
        />

        <Route
          path="/services"
          element={
            <>
              <Navbar />
              <Services />
              <Footer />
            </>
          }
        />

        <Route
          path="/contact"
          element={
            <>
              <Navbar />
              <Contact />
              <Footer />
            </>
          }
        />

        <Route
          path="/security"
          element={
            <>
              <Navbar />
              <Security />
              <Footer />
            </>
          }
        />

        <Route
          path="/dashboard/opportunityblog"
          element={
            user ? (
              user.providerData[0]?.providerId === "password" &&
              !user.emailVerified ? (
                <Navigate to="/verify-email" replace />
              ) : (
                <>
                  <OpportunityBlog />
                </>
              )
            ) : (
              <Navigate to="/Signup" replace />
            )
          }
        />

      </Routes>

    </BrowserRouter>

  )
}

export default App